import { Component, inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { LogoutPopup } from '../logout-popup/logout-popup';
import { UserDetails } from '../user-details/user-details';
import { ChangePassword } from '../change-password/change-password';
import { DefaultImage } from '../../constants/LabelConstants';
import { AuthService } from '../../services/auth-service/auth.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.scss'
})

export class Header implements OnInit {

  userName: any;
  userImage: any;
  isMenuOpen = false;

  constructor(
    private commonService: CommonService,
    private toster: ToastrService,
    private apiUrl: ApiUrlHelper,
    private readonly spinner: NgxSpinnerService,
    private readonly authService: AuthService

  ) { }

  ngOnInit(): void {
    this.getUserById();
  }

  dialog = inject(MatDialog);

  getUserById() {
    this.spinner.show();
    let api = this.apiUrl.apiUrl.User.GetUserByProfile;
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        this.spinner.hide();
        this.commonService.getUserName().subscribe((fullName) => {
          this.userName = fullName;
        });
        this.commonService.getUserImage().subscribe((profilePicture) => {
          this.userImage = profilePicture;
        });

        this.userName = response.data?.firstName + ' ' + response.data?.lastName;
        this.userImage = this.isValidImageFormat(response.data?.profilePicture) ? response.data?.profilePicture : DefaultImage;
      },
      error: (err) => {
        this.spinner.hide();
        console.error(err);
      }
    });
  }

  isValidImageFormat(url: string | null | undefined): boolean {
    if (!url || typeof url !== 'string') return false;
  
    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.svg'];
    return allowedExtensions.some(ext => url.toLowerCase().endsWith(ext));
  }
  
  openDialog() {
    this.dialog.open(UserDetails, {
      maxWidth: '500px',
      disableClose: true,
      width: '80%'
    });
  }

  openDialogChangePassword() {
    this.dialog.open(ChangePassword, {
      maxWidth: '500px',
      disableClose: true,
      width: '80%'
    });
  }

  logOut() {
    let apiUrl = this.apiUrl.apiUrl.Account.Logout;
    let action = this.userName
    const dialogRef = this.dialog.open(LogoutPopup, {
      width: '460px',
      data: { action },
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.spinner.show();
        this.commonService.doGet(apiUrl).pipe().subscribe({
          next: (response) => {
            if (response.success) {
              this.authService.logout();
              this.toster.success(response.message);
              this.spinner.hide()
            }
            else {
              this.toster.error(response.message);
              this.spinner.hide()
            }
          },
          error: (err) => {
            this.spinner.hide();
            console.error(err);
          }
        })
      }
    });
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
  
    if (!img.src.includes(DefaultImage)) {
      img.src = DefaultImage;
    }
  }
}